import compact from "lodash/compact";
import { normalizePhone } from "@stadium/helpers/form/normalizer";

import mdStyle from "../address-modal.module.scss";

const AddressView = ({
  address: {
    zipcode,
    firstname,
    lastname,
    businessName,
    phone,
    address2,
    stateAbbreviation = "",
    zipcodeNonUs = "",
    stateNameNonUs = "",
    city,
    formattedAddress,
    countryName = "",
    isInternational,
  },
}) => {
  const isNonInternationalAddress = !isInternational;
  const stateData = isNonInternationalAddress ? stateAbbreviation : stateNameNonUs;
  const zipcodeData = isNonInternationalAddress ? zipcode : zipcodeNonUs;
  const phoneData = normalizePhone(phone, {
    showBrackets: isNonInternationalAddress,
    isUsaPhone: isNonInternationalAddress,
  });

  const userLastName = lastname ?? "";
  return (
    <div className={mdStyle.adArea}>
      <div className={mdStyle.firstRow}> {`${firstname} ${userLastName}`} </div>
      <div className={mdStyle.secondRow}>
        <i className={mdStyle.iconPhone} />
        <div className={mdStyle.phoneText}> {phoneData} </div>
      </div>
      <div className={mdStyle.thirdRow}>
        {businessName && (
          <div>
            <b>{businessName}</b>
          </div>
        )}

        <div>{formattedAddress}</div>
        {address2 && <div>{address2}</div>}
        {compact([city, compact([stateData, zipcodeData]).join(" ")]).join(", ")}
        <div>{countryName}</div>
      </div>
    </div>
  );
};

export default AddressView;
